import React from 'react';
import MapIcon from '@mui/icons-material/Map';
import { VscServerEnvironment } from 'react-icons/vsc';
import { lazyPage } from '../lazyPage';

const DripIrrigation = lazyPage(() => import(/* webpackChunkName: "m-farm-ops" */ '../../pages/DripIrrigation'));
const ListAllEnvs = lazyPage(() => import(/* webpackChunkName: "m-farm-ops" */ '../../pages/ListAllEnvs'));
const Devices = lazyPage(() => import(/* webpackChunkName: "m-farm-ops" */ '../../pages/Devices'));
const FarmListPage = lazyPage(() => import(/* webpackChunkName: "m-farm-ops" */ './pages/FarmListPage'));
const FarmEditPage = lazyPage(() => import(/* webpackChunkName: "m-farm-ops" */ './pages/FarmEditPage'));
const ZoneCreatePage = lazyPage(() => import(/* webpackChunkName: "m-farm-ops" */ '../zone/pages/ZoneCreatePage'));
const ZoneEditPage = lazyPage(() => import(/* webpackChunkName: "m-farm-ops" */ '../zone/pages/ZoneEditPage'));
const UserDetails = lazyPage(() => import(/* webpackChunkName: "m-farm-ops" */ '../../pages/UserDetails'));
const RegisterForm = lazyPage(() => import(/* webpackChunkName: "m-farm-ops" */ '../../pages/RegisterForm'));

/**
 * Farm-ops manifests — WRAP the existing routes only; page internals unchanged
 * (DripIrrigation is another dev's active area — its route moves here, its code
 * does not). /farms and /devices/:envId have no sidebar entry today and keep none.
 *
 * The farm-mapping detail/edit routes (farm/zone edit, user details, register form)
 * moved here from App.js (QW5/QW6). They are route-only — no sidebar entry, no
 * behaviour change — and keep their exact URLs and their m-farm-ops chunk. Routes
 * aren't permission-gated (only sidebar items are), so ungated inline → route-only
 * manifest entry is identical at runtime.
 */
const farmOpsManifests = [
    {
        id: 'farm-ops',
        featureName: 'farm_mgmt',
        permission: 'view',
        routes: [
            { path: '/drip-irrigation', element: <DripIrrigation /> },
            { path: '/farms', element: <FarmListPage /> },
            { path: '/userdetails/:userId', element: <UserDetails /> },
            { path: '/register-form/:fullName/:userId', element: <RegisterForm /> },
            { path: '/edit-farms/:farmId/:userId', element: <FarmEditPage /> },
            { path: '/add-zone/:farmId/:userId', element: <ZoneCreatePage /> },
            { path: '/edit-zone/:farmId/:zoneId/:userId', element: <ZoneEditPage /> },
        ],
        sidebarItems: [{ text: 'Drip Irrigation', icon: <MapIcon />, link: '/drip-irrigation' }],
    },
    {
        id: 'hubs',
        featureName: 'env_mgmt',
        permission: 'view',
        routes: [
            { path: '/envs', element: <ListAllEnvs /> },
            { path: '/devices/:envId', element: <Devices /> },
        ],
        sidebarItems: [{ text: 'Hubs', icon: <VscServerEnvironment />, link: '/envs' }],
    },
];

export default farmOpsManifests;
